module.exports = "<span class=\"spinner errorReport__spinner\" ng-if=\"!vm.downloadLink\">\n  <div class=\"bounce1\"></div>\n  <div class=\"bounce2\"></div>\n  <div class=\"bounce3\"></div>\n</span>\n<a class=\"errorReport__link\" ng-if=\"vm.downloadLink\" href=\"{{vm.downloadLink}}\">\n  <div ng-if=\"vm.batchId\" class=\"icon download-small\"></div>\n  {{vm.anchorText | translate}}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/errorReport/errorReport.html
// module id = 436
// module chunks = 1